import { render, staticRenderFns } from "./infomore.vue?vue&type=template&id=0fa7ebee&scoped=true&"
import script from "./infomore.vue?vue&type=script&lang=js&"
export * from "./infomore.vue?vue&type=script&lang=js&"
import style0 from "./infomore.vue?vue&type=style&index=0&id=0fa7ebee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa7ebee",
  null
  
)

export default component.exports